import { render } from "./CorporateDirectory.vue?vue&type=template&id=2ed6953e&scoped=true"
import script from "./CorporateDirectory.vue?vue&type=script&lang=js"
export * from "./CorporateDirectory.vue?vue&type=script&lang=js"

import "./corporate-directory.scss?vue&type=style&index=0&id=2ed6953e&lang=scss&scoped=true"

import exportComponent from "/var/webapps/orangehrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed6953e"]])

export default __exports__